import React, { useState, useRef, useEffect, useLayoutEffect } from "react";
import {
  Button,
  Grid,
  InputAdornment,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  CircularProgress,
  Box,
  IconButton,
  Select,
  MenuItem,
  ClickAwayListener,
  Menu,
  Collapse,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { connect, useSelector } from "react-redux";
import { ReactComponent as SurgeryHomeIcon } from "../../Assets/Icons/PharmsmartIcon/surgeryTools.svg";
import {
  RESET_SURGERY_STATE,
  START_GET_SURGERY_LIST,
  START_DELETE_SURGERY,
  START_GET_SURGERY_NOTE_LIST,
  START_CREATE_SURGERY_NOTE,
  START_UPDATE_SURGERY_NOTE,
  START_GET_SINGLE_SURGERY_NOTE,
  START_DELETE_SURGERY_NOTE,
  START_GET_PRINT_SURGERY_LIST,
} from "../../Actions/SurgeryAction";
import { RESET_PATIENT_STATE } from "../../Actions/PatientAction";
import _ from "underscore";
import {
  getClearObject,
  getLocalStorage,
  setLocalStorage,
  getNewOrder,
} from "../../utils/generalUtils";
import { useIntersection } from "../../Hooks/customHooks";
import { ReactComponent as SearchIcon } from "../../Assets/Icons/SearchIcon.svg";
import { ReactComponent as AddIcon } from "../../Assets/Icons/AddIcon.svg";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { ReactComponent as FilterIcon } from "../../Assets/Icons/FilterIcon.svg";
import SearchAndFilterDialogSurgeryMobileView from "./SearchAndFilterDialogSurgeryMobileView";
import "../../Sass/Common.scss";
import SurgeryTable from "./SurgeryTable";
import PrimaryIcon from "../../Components/Common/PrimaryIcon";
import { ReactComponent as SettingIcon } from "../../Assets/Icons/SettingsIcon.svg";
import { ReactComponent as PrintIcon } from "../../Assets/Icons/printIcon.svg";
import TableColumnShowMenu from "../Common/Table/TableColumnShowMenu";
import useViewport from "Hooks/useViewport";
import clsx from "clsx";
import { START_GET_STAFF_LIST } from "../../Actions/StaffAction";
import { START_GET_HOME_LIST } from "../../Actions/HomeAction";
import HtmlTooltip from "../../Components/Common/HtmlTooltipMain";
import CheckIcon from "@mui/icons-material/Check";
import SubscriptionWaringDailog from "../../Components/Common/Dialog/SubscriptionWaringDailog";
import "../../Sass/SurgeryMain.scss";
import ViewWeekIcon from "@mui/icons-material/ViewWeek";
import FilterListIcon from "@mui/icons-material/FilterList";
import { ReactComponent as ModalCloseIcon } from "../../Assets/Icons/PharmsmartIcon/ModalCloseIcon.svg";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";
import DriverAutoComplete from "../../Components/Surgery/DriverAutoComplete";
const EditPhoneDialog = React.lazy(
  () => import("../../Components/Surgery/EditPhoneDialog"),
);
const CreateSurgeryDialog = React.lazy(
  () => import("../../Components/Surgery/CreateSurgeryDialog"),
);
const ConfirmationDialog = React.lazy(
  () => import("../../Components/Common/Dialog/ConfirmationDialog"),
);
// const DriverAutoComplete = React.lazy(() =>
//   import("../../Components/Surgery/DriverAutoComplete")
// );
const NotesDialog = React.lazy(
  () => import("../../Components/Surgery/NotesDialog"),
);
const PrintSurgeryList = React.lazy(() => import("./PrintSurgeryList"));

const useStyle = makeStyles((theme) => ({
  rsTableHeader: {
    display: "flex !important",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "6px 6px",
    background: "#333",
    // [theme.breakpoints.down("786")]: {
    //   display: "block !important",
    // },
  },
  rsSurgeryHeader: {
    display: "flex",
    justifyContent: "end",
    whiteSpace: "nowrap",
    "&>button": {
      marginLeft: "0",
      fontSize: "14px",
      height: "37px !important",
      background: "red",
      // [theme.breakpoints.down("1176")]: {
      //   marginRight: "-24px",
      //   marginTop: "-7px",
      // },
    },
    "&>button": {
      marginRight: "11px",
      fontSize: "14px",
      height: "37px !important",
      padding: "0px !important",
      // [theme.breakpoints.down("1176")]: {
      //   marginRight: "-24px",
      //   marginTop: "-7px",
      // },
      [theme.breakpoints.between("670", "769")]: {
        marginRight: "5px",
      },
    },
    "&>div": {
      width: "200px",
      marginRight: "5px",
      height: "37px !important",
      "&>div": {
        marginTop: "0px",
        height: "37px !important",
        "&>div": {
          height: "37px !important",
        },
      },
    },
    [theme.breakpoints.down("991")]: {
      flexDirection: "column !important",
      alignItems: "flex-end",
      "&>div:nth-child(2)": {
        marginTop: "5px",
      },
    },
    [theme.breakpoints.between("670", "769")]: {
      flexDirection: "row !important",
      // alignItems:"flex-end",
      "&>div:nth-child(2)": {
        marginTop: "0px",
      },
    },
    [theme.breakpoints.down("385")]: {
      "&>div": {
        width: "170px",
      },
    },
    [theme.breakpoints.down("354")]: {
      "&>div": {
        width: "140px",
      },
    },
  },
  rsIconBtnUser: {
    "&:hover": {
      background: `none !important`,
    },
  },
  rsSurgeryFormGroup: {
    display: "inline-flex",
    alignItems: "center",
    marginBottom: "0px",
    justifyContent: "start",
    "&>button": {
      padding: "0px !important",
      minWidth: "155px",
      minHeight: "37px",
      marginLeft: "5px",
      height: "fit-content",
      [theme.breakpoints.down("354")]: {
        minWidth: "144px",
      },
    },
    "&>div": {
      width: "200px",
    },
    [theme.breakpoints.down("991")]: {
      display: "flex",
      flexDirection: "column !important",
      justifyContent: "start",
      alignItems: "start",
      "&>div": {
        display: "flex",
        marginLeft: "5px",
        marginTop: "5px",
        "&>button": {
          minWidth: "45px !important",
          padding: "0px !important",
        },
      },
    },
    [theme.breakpoints.down("400")]: {
      display: "block",
    },
    [theme.breakpoints.down("769")]: {
      display: "block",
    },
    [theme.breakpoints.down("405")]: {
      "&>div": {
        width: "unset !important",
      },
    },

    // [theme.breakpoints.down("1176")]: {
    //   marginTop: "-15px",
    //   marginBottom: "34px",
    // },
  },
  rsSurgeryFormGroupMob: {
    display: "flex",
    alignItems: "center",
    marginBottom: "20px",
    justifyContent: "end",
    "&>button": {
      padding: "0px !important",
      minWidth: "40px",
      marginLeft: "20px",
    },
    "&>div": {
      width: "200px",
    },
    // [theme.breakpoints.down("1176")]: {
    //   marginTop: "-80px",
    //   marginBottom: "42px",
    //   marginRight: "24px",
    // },
    // [theme.breakpoints.up("1176")]: {
    //   display: "none",
    // },
    [theme.breakpoints.down("400")]: {
      display: "none",
    },
  },
  rsSurgeryFormGroupOtherMob: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    width: "200px",
    "&>button": {
      padding: "0px !important",
      minWidth: "40px",
      marginLeft: "20px",
    },

    // [theme.breakpoints.down("1176")]: {
    //   marginTop: "-9px",
    // },
    // [theme.breakpoints.up("1176")]: {
    //   display: "none",
    // },
    [theme.breakpoints.down("400")]: {
      display: "none",
    },
  },
  rsSurgeryFormGroupSmall: {
    display: "block",
    alignItems: "center",
    marginBottom: "20px",
    justifyContent: "end",
    "&>button": {
      padding: "0px !important",
      minWidth: "40px",
      marginLeft: "20px",
    },
    "&>div": {
      width: "200px",
    },
    marginTop: "-43px",
    marginBottom: "57px",
    marginLeft: "17px",
    // [theme.breakpoints.up("1176")]: {
    //   display: "none",
    // },
  },
  rsSurgeryFormControl: {
    "&>span": {
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "20px",
      // color: "#fff",
      color: "black",
      paddingLeft: "0",
      [theme.breakpoints.down("350")]: {
        fontSize: "13px",
      },
      "&>svg": {
        // background: "#333",
        // color: "white",
        background: "white",
        color: "#5A6872",
      },
    },
  },
  activecheck: {
    "&>span": {
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "20px",
      // color: "#fff",
      color: "#5A6872",
      paddingLeft: "0",
      [theme.breakpoints.down("350")]: {
        fontSize: "13px",
      },
      "&>svg": {
        background: "rgb(123, 192, 68)",
        color: "white",
      },
    },
  },
  printButton: {
    minWidth: "45px !important",
    padding: "8px !important",
    fontSize: "14px !important",
    height: "37px !important",
    marginLeft: "0px !important",
    background: "#7bc044 !important",
    "&>svg": {
      height: "20px !important",
      width: "20px !important",
      fill: "#fff !important",
    },
    // [theme.breakpoints.down("1176")]: {
    //   display: "none !important",
    // },
  },
  printButtonMob: {
    minWidth: "50px",
    padding: "8px !important",
    fontSize: "14px !important",
    height: "37px !important",
    marginTop: "222px !important",
    marginLeft: "0px !important",
    background: "#7bc044 !important",
    "&>svg": {
      height: "20px !important",
      width: "20px !important",
    },
    [theme.breakpoints.down("400")]: {
      marginLeft: "10px !important",
    },
  },
  rsSettingMob: {
    minWidth: "50px",
    padding: "8px !important",
    fontSize: "14px !important",
    height: "37px !important",
    marginTop: "12px !important",
    marginLeft: "10px !important",
    "&>svg": {
      height: "20px !important",
      width: "20px !important",
    },
  },
  formAlignment: {
    display: "contents !important",
    "& .MuiFormControlLabel-root": {
      marginLeft: "9px",
    },
    "&>label": {
      // [theme.breakpoints.down("1176")]: {
      //   position: "relative !important",
      //   top: "6px !important",
      // },
    },
  },
  rsFilterGrid: {
    padding: "0px 0px !important",
    fontSize: "14px !important",
    height: "37px !important",
    // marginTop: "10px !important",
    marginLeft: "9px !important",
    minWidth: "47px !important",
    "&>svg": {
      fill: `${theme.palette.primary.main} !important`,
    },
    // [theme.breakpoints.up("1176")]: {
    //   display: "none !important",
    // },
  },
  rsGrid: {},
  // managePageH: {
  //   "& .MuiTableContainer-root": {
  //     maxHeight: "calc(94vh - 200px) !important",
  //     padding: "13px !important",
  //     [theme.breakpoints.down("1400")]: {
  //       maxHeight: "calc(92vh - 200px) !important",
  //     },
  //     "&>table": {
  //       "&>thead": {
  //         "&>tr": {
  //           "&>th": {
  //             "&:first-child": {
  //               whiteSpace: "nowrap",
  //               position: "sticky",
  //               left: "0px",
  //               zIndex: 4,
  //             },
  //             "&:nth-child(2)": {
  //               whiteSpace: "nowrap",
  //               position: "sticky",
  //               left: 0,
  //               zIndex: 1,
  //             },
  //             "&:nth-child(3)": {
  //               whiteSpace: "nowrap",
  //               position: "sticky",
  //               left: 0,
  //               zIndex: 1,
  //             },
  //             "&:nth-child(4)": {
  //               whiteSpace: "nowrap",
  //               position: "sticky",
  //               // right: "0",
  //               zIndex: 1,
  //               [theme.breakpoints.down("1176")]: {
  //                 left: 0,
  //               },
  //             },
  //             "&:nth-child(5)": {
  //               whiteSpace: "nowrap",
  //               position: "sticky",
  //               // right: 0,
  //               zIndex: 1,
  //             },
  //             "&:nth-child(6)": {
  //               whiteSpace: "nowrap",

  //               position: "sticky",
  //               // right: "-37px",
  //               // right: "0px",

  //               zIndex: 1,
  //             },
  //             "&:nth-child(7)": {
  //               whiteSpace: "nowrap",
  //               position: "sticky",
  //               // right: "0px",
  //               // right: "-27px",
  //               zIndex: 1,
  //               [theme.breakpoints.down("1400")]: {
  //                 right: "-20px",
  //               },
  //             },
  //             "&:last-child": {
  //               position: "sticky",
  //               right: "0px",
  //               padding: "0 10px !important",
  //               zIndex: 4,
  //               // minWidth: "100px !important",
  //             },
  //           },
  //         },
  //       },
  //       "&>tbody": {
  //         "&>tr": {
  //           "&>td": {
  //             "&:first-child": {
  //               background: "#ffffff",
  //               position: "sticky",
  //               left: "0px",
  //               zIndex: 3,
  //             },
  //             "&:nth-child(2)": {
  //               position: "sticky",
  //               left: 0,
  //               zIndex: 0,
  //             },
  //             "&:nth-child(3)": {
  //               position: "sticky",
  //               left: 0,
  //               zIndex: 0,
  //             },
  //             "&:nth-child(4)": {
  //               [theme.breakpoints.down("1300")]: {
  //                 whiteSpace: "pre-line !important",
  //               },
  //               [theme.breakpoints.down("1176")]: {
  //                 left: 0,
  //               },
  //               position: "sticky",
  //               // right: "0",
  //               zIndex: 0,
  //             },
  //             "&:nth-child(5)": {
  //               position: "sticky",
  //               // right: 0,
  //               zIndex: 0,
  //               [theme.breakpoints.down("1300")]: {
  //                 whiteSpace: "normal !important",
  //               },
  //               [theme.breakpoints.down("1367")]: {
  //                 whiteSpace: "pre-line !important",
  //               },
  //             },
  //             "&:nth-child(6)": {
  //               position: "sticky",
  //               // right: "-16px",
  //               // right: "0px",

  //               zIndex: 0,
  //             },
  //             "&:nth-child(7)": {
  //               position: "sticky",
  //               // right: "-27px",
  //               // right: "0px",
  //               zIndex: 0,
  //               [theme.breakpoints.down("1400")]: {
  //                 right: "-33px",
  //               },
  //             },
  //             "&:last-child": {
  //               background: "#ffffff",
  //               position: "sticky",
  //               right: "0px",
  //               padding: "0px 3px !important",
  //               zIndex: 3,
  //             },
  //           },
  //         },
  //       },
  //     },
  //   },
  // },
  managePageHMob: {
    "& .MuiTableContainer-root": {
      // maxHeight: "calc(94vh - 200px) !important",
      // padding: "13px !important",
      // [theme.breakpoints.down("1400")]: {
      //   maxHeight: "calc(92vh - 200px) !important",
      // },
      [theme.breakpoints.down("990")]: {
        maxHeight: "calc(100vh - 220px) !important",
      },
      [theme.breakpoints.down("769")]: {
        maxHeight: "calc(100vh - 220px) !important",
      },
      [theme.breakpoints.down("385")]: {
        maxHeight: "calc(100vh - 230px) !important",
      },
      "&>table": {
        "&>thead": {
          "&>tr": {
            "&>th": {
              lineHeight: "1.2rem",
              padding: "11px 16px",
              borderBottom: "3px solid #dddddd",
              borderLeft: "3px solid #dddddd",
              "&:first-child": {
                whiteSpace: "nowrap",
                position: "sticky",
                // left: "0px",
                zIndex: 4,
              },
              "&:nth-child(2)": {
                borderLeft: "none !important",
                whiteSpace: "nowrap",
                position: "sticky",
                // left: 0,
                zIndex: 1,
              },
              "&:nth-child(3)": {
                whiteSpace: "nowrap",
                position: "sticky",
                // left: 0,
                zIndex: 1,
              },
              "&:nth-child(4)": {
                whiteSpace: "nowrap",
                position: "sticky",
                // right: "0",
                zIndex: 1,
                // [theme.breakpoints.down("1176")]: {
                //   left: 0,
                // },
                // [theme.breakpoints.down("769")]: {
                //   left: "",
                // },
              },
              "&:nth-child(5)": {
                whiteSpace: "nowrap",
                position: "sticky",
                // right: 0,
                zIndex: 1,
              },
              "&:nth-child(6)": {
                whiteSpace: "nowrap",

                position: "sticky",
                // right: "-37px",
                // right: "0px",

                zIndex: 1,
              },
              "&:nth-child(7)": {
                whiteSpace: "nowrap",
                position: "sticky",
                // right: "0px",
                // right: "-27px",
                zIndex: 1,
                // [theme.breakpoints.down("1400")]: {
                //   right: "-20px",
                // },
              },
              "&:last-child": {
                position: "sticky",
                // right: "0px",
                padding: "0 10px !important",
                zIndex: 4,
                // minWidth: "100px !important",
              },
            },
          },
        },
        "&>tbody": {
          "&>tr": {
            "&>td": {
              "&:first-child": {
                background: "#ffffff",
                position: "relative",
                left: "0px",
                zIndex: 3,
              },
              "&:nth-child(2)": {
                borderLeft: "none !important",
                position: "relative",
                left: 0,
                zIndex: 0,
              },
              "&:nth-child(3)": {
                position: "relative",
                left: 0,
                zIndex: 0,
              },
              "&:nth-child(4)": {
                [theme.breakpoints.down("1300")]: {
                  whiteSpace: "pre-line !important",
                  minWidth: "240px",
                },
                // [theme.breakpoints.down("1176")]: {
                //   left: 0,
                // },
                position: "relative",
                // right: "0",
                zIndex: 0,
              },
              "&:nth-child(5)": {
                position: "relative",
                // right: 0,
                zIndex: 0,
                [theme.breakpoints.down("1300")]: {
                  whiteSpace: "normal !important",
                },
                [theme.breakpoints.down("1367")]: {
                  whiteSpace: "pre-line !important",
                },
              },
              "&:nth-child(6)": {
                position: "relative",
                // right: "-16px",
                // right: "0px",

                zIndex: 0,
              },
              "&:nth-child(7)": {
                position: "relative",
                // right: "-27px",
                // right: "0px",
                zIndex: 0,
                // [theme.breakpoints.down("1400")]: {
                //   right: "-33px",
                // },
              },
              "&:last-child": {
                background: "#ffffff",
                position: "relative",
                right: "0px",
                padding: "0px 3px !important",
                zIndex: 3,
              },
            },
          },
        },
      },
    },
  },
  managePageH: {
    // marginTop: "5px",
    "& .MuiTableContainer-root": {
      // height: "calc(100vh - 174px) !important",
      maxHeight: "calc(96vh - 148px) !important",
      padding: "0 !important",
      "&>table": {
        "&>thead": {
          "&>tr": {
            "&>th": {
              lineHeight: "1.2rem",
              padding: "11px 16px",
              borderBottom: "3px solid #dddddd",
              borderLeft: "3px solid #dddddd",
              "&:first-child": {
                whiteSpace: "nowrap",
                position: "sticky",
                left: "0px",
                zIndex: 4,
              },
              "&:nth-child(2)": {
                whiteSpace: "nowrap",
                position: "sticky",
                left: 0,
                zIndex: 1,
                borderLeft: "none !important",
              },
              "&:nth-child(3)": {
                whiteSpace: "nowrap",
                position: "sticky",
                left: 0,
                zIndex: 1,
              },
              "&:nth-child(4)": {
                whiteSpace: "nowrap",
                position: "sticky",
                // right: "0",
                zIndex: 1,
                minWidth: "200px !important",
                // [theme.breakpoints.down("1176")]: {
                //   left: 0,
                // },
              },
              "&:nth-child(5)": {
                whiteSpace: "nowrap",
                position: "sticky",
                // right: 0,
                zIndex: 1,
              },
              "&:nth-child(6)": {
                whiteSpace: "nowrap",

                position: "sticky",
                // right: "-37px",
                // right: "0px",

                zIndex: 1,
              },
              "&:nth-child(7)": {
                whiteSpace: "nowrap",
                position: "sticky",
                // right: "0px",
                // right: "-27px",
                zIndex: 1,
                // [theme.breakpoints.down("1400")]: {
                //   right: "-20px",
                // },
              },
              "&:nth-child(8)": {
                whiteSpace: "nowrap",
                position: "sticky",
                // right: "0px",
                // right: "-27px",
                zIndex: 1,
                // [theme.breakpoints.down("1400")]: {
                //   right: "-20px",
                // },
              },
              "&:last-child": {
                position: "sticky",
                right: "0px",
                padding: "0 10px !important",
                zIndex: 4,
                // minWidth: "100px !important",
              },
            },
          },
        },
        "&>tbody": {
          "&>tr": {
            "&>td": {
              "&:first-child": {
                background: "#ffffff",
                position: "sticky",
                left: "0px",
                zIndex: 3,
              },
              "&:nth-child(2)": {
                position: "sticky",
                left: 0,
                zIndex: 0,
                borderLeft: "none !important",
              },
              "&:nth-child(3)": {
                position: "sticky",
                left: 0,
                zIndex: 0,
              },
              "&:nth-child(4)": {
                [theme.breakpoints.down("1300")]: {
                  whiteSpace: "pre-line !important",
                  minWidth: "240px",
                },
                [theme.breakpoints.between("1300", "1921")]: {
                  minWidth: "220px !important",
                },
                [theme.breakpoints.up("1921")]: {
                  minWidth: "280px !important",
                },
                // [theme.breakpoints.down("1176")]: {
                //   left: 0,
                // },
                padding: "2px 10px !important",
                minWidth: "220px !important",
                position: "sticky",
                // right: "0",
                zIndex: 0,
              },
              "&:nth-child(5)": {
                position: "sticky",
                // right: 0,
                zIndex: 0,
                [theme.breakpoints.down("1300")]: {
                  whiteSpace: "normal !important",
                },
                [theme.breakpoints.down("1367")]: {
                  whiteSpace: "pre-line !important",
                },
              },
              "&:nth-child(6)": {
                position: "sticky",
                // right: "-16px",
                // right: "0px",

                zIndex: 0,
              },
              "&:nth-child(7)": {
                position: "sticky",
                // right: "-27px",
                // right: "0px",
                zIndex: 0,
                // [theme.breakpoints.down("1400")]: {
                //   right: "-33px",
                // },
              },
              "&:nth-child(8)": {
                position: "sticky",
                // right: "-27px",
                // right: "0px",
                zIndex: 0,
                // [theme.breakpoints.down("1400")]: {
                //   right: "-33px",
                // },
              },
              "&:last-child": {
                background: "#ffffff",
                position: "sticky",
                right: "0px",
                padding: "0px 3px !important",
                zIndex: 3,
              },
            },
          },
        },
      },
    },
  },
  globalSettingIcon: {
    // [theme.breakpoints.down("1176")]: {
    //   display: "none !important",
    // },
  },
  globalSettingIconDriver: {
    margin: "4px 5px",
    // [theme.breakpoints.down("1176")]: {
    //   margin: "-3px 5px",
    // },
  },
  globalSettingIconDriverWeb: {
    margin: "6px -4px",
    // [theme.breakpoints.down("1176")]: {
    //   display: "none !important",
    // },
  },
  dayAutocomplete: {
    background: theme.palette.white.main,
    boxShadow: "0px 0px 10px rgb(90 104 114 / 10%)",
    borderRadius: "4px",
    lineHeight: "30px",
    minWidth: "253px !important",
    maxWidth: "253px !important",
    whiteSpace: "onwrap",
    height: "39px",
    marginRight: "13px",
    "&>div": {
      marginTop: "3px",
      padding: "10px",
      color: theme.palette.secondary.main,
      fontSize: "14px",
      height: "23px !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
    "& .MuiMenuItem": {
      color: theme.palette.secondary.main,
    },
    [theme.breakpoints.down("1350")]: {
      minWidth: "200px !important",
    },
  },
  rsMainMarign: {
    [theme.breakpoints.down(769)]: {
      marginTop: "30px !important",
    },
  },
  search: {
    marginTop: "0px !important",
    marginRight: "11px !important",
    [theme.breakpoints.down("991")]: {
      marginRight: "5px !important",
    },
  },
  isExpandSearch: {
    transform: "unset",
    transition: "all 0.4s ease",
    cursor: "default !important",
    width: "200px !important",
    marginRight: "3px !important",
    "&>div": {
      margin: "0px 0px",
      "&>div": {
        "&>div": {
          marginRight: "-4px !important",
        },
      },
    },
  },
  textSearch: {
    cursor: "default !important",
    width: "40px !important",
    marginRight: "3px !important",
    "&>div": {
      margin: "0px 0px",
      "&>div": {
        // paddingRight: "3px !important",
        paddingLeft: "10px !important",
        "&>div": {
          // marginLeft: "-18px",
        },
        "&>input": {
          padding: "0px 2px !important",
          width: "0px",
        },
      },
      "&>input": {
        padding: "0px  !important",
        width: "0px",
      },
    },
  },
  rsiconBtnForFilter: {
    width: "auto !important",
    marginRight: "11px !important",
    "&>div": {
      background: "white !important",
      display: "flex !important",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "5px",
      color: "black !important",
      // cursor: "pointer",
      width: "auto !important",
      height: "40px !important",
      padding: "6px",
      "&>button": {
        padding: "4px",
        cursor: "pointer",
        color: "black",
        fontSize: "16px",
        "&:hover": {
          background: "transparent",
        },
        "&>svg": {
          fill: "black",
          "&>rect": {
            fill: "black",
          },
          // fontSize: "35px",
        },
      },
      [theme.breakpoints.down("991")]: {
        height: "37px !important",
      },
    },
    "&>hr": {
      color: "#5A6872",
      background: "#5A6872",
      paddingTop: "5px",
      paddingBottom: "5px",
    },
    [theme.breakpoints.between("670", "769")]: {
      marginRight: "5px !important",
    },
  },
  rsCursor: {
    cursor: "pointer",
  },
  rsListAlignment: {
    display: "flex",
    marginBottom: "11px",
    justifyContent: "space-between",
    "&>div": {
      display: "flex",
    },
  },
  rsWaringFilterlistview: {
    "&>li": {
      display: "block",
      marginBottom: "15px",
      // marginTop: "10px",
      "&>svg": {
        top: "5px",
        position: "relative",
      },
    },
  },

  rsSurgeryAutoCompleteWebOther: {
    height: "37px",
    marginTop: "0px !important",
    width: "150px !important",
    [theme.breakpoints.down("1650")]: {
      width: "150px !important",
    },
    "&>div": {
      // border: "1px solid black !important",
      marginTop: "0px !important",
      "&>div": {
        border: "1px solid black !important",
        "&:focus": {
          borderColor: "#7BC044 !important",
        },
        "&:focus-within": {
          borderColor: "#7BC044 !important",
        },
      },
    },
  },
  rsButtonHowtoIcon: {
    // background: "#7bc044 !important",
    padding: "10px !important",
    borderRadius: "5px !important",
    marginLeft: "4px",
    "&>svg": {
      "&>path": {
        fill: "white !important",
        stroke: "white !important",
      },
    },
  },
  filterCount: {
    paddingRight: "5px",
  },
}));

const tableCells = {
  name: {
    id: "name",
    label: "SURGERY",
    sortable: true,
    numeric: false,
    show: true,
    showValue: false,
  },
  driver: {
    id: "driver",
    label: "DRIVER",
    sortable: false,
    numeric: true,
    show: true,
    showValue: true,
  },
  driver_goes_days: {
    id: "driver_goes_days",
    label: "DRIVER DAYS",
    sortable: false,
    numeric: true,
    show: true,
    showValue: true,
  },
  address: {
    id: "address",
    label: "ADDRESS",
    sortable: true,
    numeric: true,
    show: true,
    showValue: true,
  },
  no_of_collection: {
    id: "no_of_collection",
    label: "WAITING PRESCRIPTIONS",
    sortable: false,
    numeric: true,
    show: false,
    showValue: true,
  },
  pharmacy_collection: {
    id: "pharmacy_collection",
    label: "PHARMACY COLLECTIONS",
    sortable: true,
    numeric: true,
    show: true,
    showValue: true,
  },
  best_ordering_method: {
    id: "ordering_method",
    label: "BEST ORDERING METHOD",
    sortable: true,
    numeric: true,
    show: false,
    showValue: true,
  },
  phone_no: {
    id: "phone",
    label: "PHONE NO",
    sortable: true,
    numeric: true,
    show: false,
    showValue: true,
  },
  action: {
    id: "action",
    label: "ACTIONS",
    sortable: false,
    show: true,
    showValue: false,
    printShow: false,
  },
};

const tableCellsPharmacy = {
  name: {
    id: "name",
    label: "SURGERY",
    sortable: true,
    numeric: false,
    show: true,
    showValue: false,
  },
  driver: {
    id: "driver",
    label: "DRIVER",
    sortable: false,
    numeric: true,
    show: true,
    showValue: true,
  },

  driver_goes_days: {
    id: "driver_goes_days",
    label: "DRIVER DAYS",
    sortable: false,
    numeric: true,
    show: true,
    showValue: true,
  },
  address: {
    id: "address",
    label: "ADDRESS",
    sortable: true,
    numeric: true,
    show: true,
    showValue: true,
  },
  no_of_collection: {
    id: "no_of_collection",
    label: "WAITING PRESCRIPTIONS",
    sortable: false,
    numeric: true,
    show: false,
    showValue: true,
  },
  best_ordering_method: {
    id: "best_ordering_method",
    label: "BEST ORDERING METHOD",
    sortable: true,
    numeric: true,
    show: false,
    showValue: true,
  },
  phone_no: {
    id: "phone",
    label: "PHONE NO",
    sortable: true,
    numeric: true,
    show: true,
    showValue: true,
  },
  action: {
    id: "action",
    label: "ACTIONS",
    sortable: false,
    show: true,
    showValue: false,
    printShow: false,
  },
};

const SurgeriesMain = (props) => {
  const classes = useStyle();
  const {
    getSurgeryListAction,
    driverList,
    surgeryList,
    deleteSurgeryAction,
    deleteSurgeryData,
    resetSurgeryState,
    getSurgeryNoteListAction,
    createSurgeryNoteListAction,
    updateSurgeryNoteListAction,
    getSingletSurgeryNoteListAction,
    deleteSurgeryNoteListAction,
    surgeryNoteList,
    createSurgeryNoteData,
    updateSurgeryNoteData,
    singleSurgeryNote,
    deleteSurgeryNoteData,
    resetPatientState,
    getPrintSurgeryListAction,
    printSurgeryList,
    getStaffListAction,
    getHomeListAction,
    globalSetting,
  } = props;
  const selectedHeaderPharmacyId = getLocalStorage("Pharmacies", true);
  const [isOpenSurgeryModel, setIsOpenSurgeryModel] = useState(false);
  const [setTarget, entry] = useIntersection({ threshold: 0.1 });
  const [searchValue, setSearchValue] = useState("");
  const [deleteSurgery, setDeleteSurgery] = useState(false);
  const [surgeryDeleteId, setSurgeryDeleteId] = useState("");
  const [editSurgeryData, setEditSurgeryData] = useState({});
  const [surgeryRecordActionType, setSurgeryRecordActionType] = useState("");
  const [checkedCollection, setCheckedCollection] = React.useState(false);
  const [changeDropDownValue, setChangeDropDownValue] = useState([]);
  const [showNoteList, setShowNoteList] = useState({});
  const [openNoteList, setOpenNoteList] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [filterCount, setFilterCount] = useState(0);
  const [driverOpen, setDriverOpen] = useState(false);
  const [firstChangeDriver, setFirstChangeDriver] = useState(true);
  const isFetchedRef = useRef(false);
  const surgeryListRecordLimit = 20;
  const maxValue = 1;
  const driverListFlag = true;
  const defaultColumnOrderBy = "asc";
  const [columnSortingOrder, setColumnSortingOrder] = useState({
    orderBy: "",
    sortBy: "",
  });
  const [patientCount, setPatientCount] = useState("");
  const [showPatientData, setShowPatientData] = useState(false);
  const { headerSelectedPharmaciesFilter, loginUserDetail } = useSelector(
    (state) => state.user,
  );
  const [openFilterPopup, setOpenFilterPopup] = useState(false);
  const showDataBasedOnRole = loginUserDetail?.data?.data?.role;
  const [openTableColumn, setOpenTableColumn] = useState(false);
  const [tableColumns, setTableColumns] = useState({});
  const [columnsPopperAnchorEl, setColumnsPopperAnchorEl] = useState(null);
  const activeColumns =
    getLocalStorage("dynamicColumnSurgery")?.split(",") || [];
  const columnSequence =
    getLocalStorage("dynamicColumnSequenceSurgery")?.split(",") || [];

  /** Get surgery api main Function */
  const openTableScroll = false;
  const [isOpenEditDateModel, setIsOpenEditDateModel] = useState(false);
  const [editRepeatDate, setEditRepeatDate] = useState({});
  const [col, setCol] = useState("");
  const { width } = useViewport();
  const [orderDayfilter, setOrderDayfilter] = useState("All orders");
  const open = Boolean(openTableColumn);
  const openFilter = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const [orderDayValue, setOrderDayValue] = useState("");
  const [subscriptionDialog, setSubscritionDialog] = useState(false);
  const orderDayMenuItems = [
    { index: 0, lable: "All orders", value: "0" },
    { index: 1, lable: "Orders made after 24 hours", value: "24" },
    { index: 2, lable: "Orders made after 48 hours", value: "48" },
    { index: 3, lable: "Orders made after 72 hours", value: "72" },
  ];
  /** Get surgery api main funcation */
  const getList = (params = {}) => {
    let payload = {
      offset: 0,
      limit: surgeryListRecordLimit,
      q: searchValue,
      collection_only: checkedCollection,
      driver_ids: Object.keys(changeDropDownValue),
      order_by: params.orderBy || columnSortingOrder.orderBy,
      sort_by: (params.sortBy || columnSortingOrder.sortBy).toUpperCase(),
    };

    if (showDataBasedOnRole === "user") {
      payload.after_order_date_hour = params.driverHours;
    }
    payload = {
      ...payload,
      ...params,
    };
    delete payload.driverHours;

    getSurgeryListAction(getClearObject(payload));
  };

  useEffect(() => {
    if (getLocalStorage("urlsurgery") == "surgery") {
      return;
    }
    if (
      Object.keys(surgeryList?.data).length === 0 &&
      surgeryList?.loading === false &&
      surgeryList?.success === false
    ) {
      getList();
    }
  }, [surgeryList?.data]);

  useEffect(() => {
    if (isFetchedRef.current) {
      return;
    }

    let driverHourData;
    let payload;

    let role = loginUserDetail?.data?.data?.role;

    if (role === "user") {
      if (globalSetting?.data?.DriverHoursSetting === undefined) {
        return;
      }

      driverHourData = globalSetting?.data?.DriverHoursSetting?.gs_value;

      let textFromOrderDayMenuItems = orderDayMenuItems.find(
        (item) => item?.value === driverHourData?.toString(),
      )?.lable;

      setOrderDayfilter(textFromOrderDayMenuItems);
      setOrderDayValue(driverHourData);

      payload = {
        offset: 0,
        collection_only: false,
        limit: 20,
        after_order_date_hour: driverHourData,
      };
    } else {
      payload = {
        offset: 0,
        collection_only: false,
        limit: 20,
      };
    }

    if (getLocalStorage("urlsurgery") == "surgery") {
      isFetchedRef.current = true;
      getSurgeryListAction(payload);
      setLocalStorage("urlsurgery", "none");
    } else {
      isFetchedRef.current = true;
      getSurgeryListAction(payload);
    }
    return () => {
      if (window.location.pathname !== "/surgery") {
        // getSurgeryListAction(payload);
        // window.onbeforeunload = null;
        // setLocalStorage("pharmacyChange", false);
      }
    };
  }, [globalSetting, loginUserDetail]);
  useEffect(() => {
    if (getLocalStorage("collectionModule") === "true") {
      let payload = {
        offset: 0,
        limit: surgeryListRecordLimit,
        // q: searchValue,
        collection_only: checkedCollection,
        // driver_ids: Object.keys(changeDropDownValue),
        // all_record: true,
      };
      if (getLocalStorage("uncollectPrescription") === "true") {
        setCheckedCollection(true);
        payload.collection_only = true;
      }
      if (getLocalStorage("driver")) {
        payload.driver_ids = Object.keys(JSON.parse(getLocalStorage("driver")));
        setChangeDropDownValue(JSON.parse(getLocalStorage("driver")));
      }
      // if (getLocalStorage("surgerySearch")) {
      //   // setSearchValue(getLocalStorage("surgerySearch"));
      //   payload.q = getLocalStorage("surgerySearch");
      // }
      if (getLocalStorage("orderDay")) {
        let count = orderDayMenuItems?.find(
          (item) => item?.lable == getLocalStorage("orderDay"),
        );
        payload.after_order_date_hour = count?.value;
      }
      setOrderDayfilter(getLocalStorage("orderDay"));
      setLocalStorage("collectionModule", false);
      // getList(payload);
    }
  }, []);
  /** Pagination UseEffect */
  useEffect(() => {
    if (entry.isIntersecting) {
      if (
        surgeryList?.data?.list?.length != surgeryList?.data?.filterd_record
      ) {
        getList({
          offset: surgeryList?.data?.list?.length,
          limit: surgeryListRecordLimit,
          order_by: columnSortingOrder.orderBy,
          sort_by: columnSortingOrder.sortBy.toUpperCase(),
        });
      }
    }
  }, [entry]);

  /** Search use Ref debounce function */
  const searchUserDebounce = useRef(
    _.debounce((searchString, otherStateValues = {}) => {
      getList({
        ...(searchString && {
          q: searchString,
        }),
        ...otherStateValues,
      });
    }, 500),
  );

  /** Handle search surgery funcation */
  const handleSearch = (newValue) => {
    searchUserDebounce.current(newValue, {
      collection_only: checkedCollection,
      driver_ids: Object.keys(changeDropDownValue),
      order_by: columnSortingOrder.orderBy,
      sort_by: columnSortingOrder.sortBy.toUpperCase(),
      driverHours: orderDayValue,
    });
  };
  /** Handle Surgery Delete api calling funcation */
  const handleDeleteSurgery = () => {
    // if (loginUserDetail?.data?.data?.is_expired) {
    //   setSubscritionDialog(true);
    // } else {
    let payLoad = {};
    let payload = {
      offset: 0,
    };
    deleteSurgeryAction(surgeryDeleteId);
    // getStaffListAction(payload);
    // getHomeListAction(payLoad);
    // }
  };

  /** Handle selection Collection */
  const handleSelectCollection = (e) => {
    let isChecked = !checkedCollection;
    if (isChecked) {
      setFilterCount((prevCount) => prevCount + 1);
    } else {
      setFilterCount((prevCount) => prevCount - 1);
    }
    setCheckedCollection(isChecked);
    getList({
      collection_only: isChecked,
    });
  };

  /** Handle Change drive */
  const handleDriverChange = (value) => {
    if (Object.keys(value).length == 0) {
      setFilterCount((prevCount) => prevCount - 1);
      setFirstChangeDriver(true);
    }
    if (firstChangeDriver) {
      if (Object.keys(value).length == 1) {
        setFilterCount((prevCount) => prevCount + 1);
      }
      setFirstChangeDriver(false);
    }
    setChangeDropDownValue(value);

    if (showDataBasedOnRole === "user") {
      getList({
        driver_ids: Object.keys(value),
        after_order_date_hour: orderDayValue,
      });
    } else {
      getList({
        driver_ids: Object.keys(value),
      });
    }
  };

  /** Delete Surgery loading useEffect */
  useEffect(() => {
    if (
      !deleteSurgeryData?.loading &&
      Object.keys(deleteSurgeryData?.data)?.length
    ) {
      setDeleteSurgery(false);
      setSurgeryDeleteId("");
      resetSurgeryState("deleteSurgeryData", "");
      // getHomeListAction();
    }
  }, [deleteSurgeryData]);
  useEffect(() => {
    if (columnSortingOrder.orderBy && columnSortingOrder.sortBy) {
      getList();
    }
  }, [columnSortingOrder.orderBy, columnSortingOrder.sortBy]);
  /** Detect column order changes */
  // useEffect(() => {
  //   getList();
  // }, [columnSortingOrder]);

  /**print handle submit */
  const handelGetSurgeryPrintData = (data) => {
    let payload = {
      offset: 0,
      limit: surgeryListRecordLimit,
      q: searchValue,
      collection_only: checkedCollection,
      driver_ids: Object.keys(changeDropDownValue),
      all_record: true,
    };

    if (selectedHeaderPharmacyId != "all") {
      payload.pharmacy_id = [selectedHeaderPharmacyId];
    }
    setShowPatientData(true);
    getPrintSurgeryListAction(getClearObject(payload));
  };

  const handleSelectOrderDay = (e) => {
    setLocalStorage("orderDay", e.target.value);
    setOrderDayfilter(e.target.value);
  };

  /** print repeat order function */
  const SurgeryAction = () => {
    let printContents = document.getElementById("print-order-data").innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    window.close();
    document.body.innerHTML = originalContents;
    document.getElementById("print-order-data").remove();
  };

  window.addEventListener("afterprint", (event) => {
    if (showPatientData === true) {
      setShowPatientData(false);
      resetSurgeryState("printRepeatOrderList", { loading: false, data: [] });
      window.location.reload();
    }
  });

  /** Print Api call useEffect */
  useEffect(() => {
    if (printSurgeryList.data?.length > 0) {
      SurgeryAction();
    }
  }, [printSurgeryList.data]);

  //Set value after page refresh useEffect
  useLayoutEffect(() => {
    let allColumns =
      ["pharmacist_staff", "pharmacy"].indexOf(showDataBasedOnRole) !== -1
        ? tableCellsPharmacy
        : tableCells;

    if (activeColumns.length > 0) {
      Object.keys(allColumns)?.map((key) => {
        if (allColumns[key].showValue) {
          if (activeColumns.indexOf(allColumns[key].id) !== -1) {
            allColumns[key].show = true;
          } else {
            allColumns[key].show = false;
          }
        }
      });
    }
    allColumns = getNewOrder(columnSequence, allColumns);
    setTableColumns(allColumns);
  }, []);
  const handleClickFilter = (event) => {
    setAnchorEl(event?.currentTarget);
  };
  const handleClickFilterClear = () => {
    setChangeDropDownValue([]);
    setFirstChangeDriver(true);
    setCheckedCollection(false);
    setFilterCount(0);
    let payload = {
      offset: 0,
      limit: 20,
      collection_only: false,
      driver_ids: [],
    };
    if (selectedHeaderPharmacyId !== "" && selectedHeaderPharmacyId !== "all") {
      payload.pharmacy_id = [selectedHeaderPharmacyId];
    }

    if (showDataBasedOnRole === "user") {
      payload.after_order_date_hour = orderDayValue;
    }

    if (searchValue !== "") {
      payload.q = searchValue;
    }

    getList(payload);
  };
  const handleCloseFilter = () => {
    setAnchorEl(null);
  };
  const handleDriverOpen = () => {
    setDriverOpen(!driverOpen);
  };
  return (
    <>
      <Grid className={classes.rsTableFormGroup}>
        <Box className={classes.rsTableHeader}>
          <Grid className={classes.rsSurgeryFormGroup} container>
            {showDataBasedOnRole !== "user" && (
              <HtmlTooltip title="" className="hoverAlign">
                {/* <IconButton
                  className={classes.rsButtonHowtoIcon}
                  variant="contained"
                  onClick={() => {
                    setSurgeryRecordActionType("createNewSurgery");
                    setIsOpenSurgeryModel(true);
                  }}
                >
                  <PrimaryIcon
                    width="20px"
                    cursor="pointer"
                    icon={SurgeryHomeIcon}
                  />
                </IconButton> */}

                <Button
                  className={classes.rsButtonHowtoIcon}
                  variant="contained"
                  startIcon={
                    <PrimaryIcon
                      icon={AddIcon}
                      color="white"
                      width="16px"
                      height="16px"
                    />
                  }
                  onClick={() => {
                    setSurgeryRecordActionType("createNewSurgery");
                    setIsOpenSurgeryModel(true);
                  }}
                >
                  Create Surgery
                </Button>
              </HtmlTooltip>
            )}
            {/* {width < 1300 && (
              <HtmlTooltip title="Filter">
                <Button
                  className={classes.rsFilterGrid}
                  variant="outlined"
                  onClick={() => {
                    setOpenFilterPopup(true);
                  }}
                >
                  <PrimaryIcon
                    color="primary"
                    width="20px"
                    height="37px"
                    icon={FilterIcon}
                  />
                </Button>
              </HtmlTooltip>
            )} */}
            {((width <= 990 && width > 768) || width < 670) && (
              <Grid>
                <Box className={classes.rsiconBtnForFilter}>
                  <Box>
                    <Button onClick={handleClickFilter}>
                      <FilterListIcon />
                      <Box className={classes.filterCount}>
                        {filterCount > 0 && filterCount}
                      </Box>
                      Filter
                    </Button>
                    {filterCount > 0 && (
                      <IconButton onClick={handleClickFilterClear}>
                        <ModalCloseIcon />
                      </IconButton>
                    )}
                  </Box>
                  <Menu
                    id="long-menu"
                    MenuListProps={{
                      "aria-labelledby": "long-button",
                    }}
                    anchorEl={anchorEl}
                    open={openFilter}
                    onClose={handleCloseFilter}
                    PaperProps={{
                      style: {
                        padding: "10px",
                        // maxHeight: ITEM_HEIGHT * 4.5,
                        width: "32ch",
                      },
                    }}
                  >
                    <li
                      className={classes.rsCursor}
                      onClick={() => handleDriverOpen()}
                    >
                      <Box className={classes.rsListAlignment}>
                        <Box>
                          Drivers
                          {/* {Object.keys(changeSurgeryDropDownValue).length !== 0 && (
                        <Box className={classes.rsActiveBtn}></Box>
                      )} */}
                        </Box>
                        <PrimaryIcon
                          width="20px"
                          height="20px"
                          icon={
                            driverOpen
                              ? KeyboardArrowUpOutlinedIcon
                              : KeyboardArrowDownOutlinedIcon
                          }
                        />
                      </Box>
                    </li>
                    <Collapse in={driverOpen}>
                      <ul className={classes.rsWaringFilterlistview}>
                        <li>
                          <DriverAutoComplete
                            fullWidth
                            multiple
                            className={clsx(
                              "autoCompleteBox",
                              classes.rsSurgeryAutoCompleteWebOther,
                            )}
                            value={changeDropDownValue}
                            maxValue={maxValue}
                            driverListFlag={driverListFlag}
                            handleChange={(value) => handleDriverChange(value)}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Driver List"
                              />
                            )}
                          />
                        </li>
                      </ul>
                    </Collapse>
                    <hr />
                    <li className={classes.customMenuItem} disableRipple>
                      <Box
                        display={width > 600 ? "flex" : "block"}
                        alignItems={"center"}
                        justifyContent={"flex-start"}
                      >
                        <FormGroup className={classes.formAlignment}>
                          <FormControlLabel
                            className={
                              checkedCollection
                                ? classes.activecheck
                                : classes.rsSurgeryFormControl
                            }
                            control={
                              <Checkbox
                                checkedIcon={<CheckIcon />}
                                className={
                                  checkedCollection ? "uncollect_effect" : ""
                                }
                                color="secondary"
                                checked={checkedCollection}
                                onChange={handleSelectCollection}
                              />
                              // <Checkbox
                              //   color="secondary"
                              //   checked={checkedCollection}
                              //   onChange={handleSelectCollection}
                              // />
                            }
                            label="Waiting prescriptions only"
                          />
                        </FormGroup>
                      </Box>
                    </li>
                  </Menu>
                </Box>

                <HtmlTooltip title="Print">
                  <Button
                    className={classes.printButton}
                    variant="outlined"
                    disabled={printSurgeryList?.loading}
                    startIcon={
                      printSurgeryList?.isLoading && (
                        <CircularProgress
                          size="20px"
                          className="rsCircularIcon"
                        />
                      )
                    }
                    onClick={() => {
                      handelGetSurgeryPrintData();
                    }}
                  >
                    <PrimaryIcon
                      icon={PrintIcon}
                      color="primary"
                      width="26px"
                      height="26px"
                    />
                  </Button>
                </HtmlTooltip>
              </Grid>
            )}
          </Grid>

          <Grid className={classes.rsSurgeryHeader}>
            {showDataBasedOnRole === "user" &&
              width >= 1300 &&
              orderDayValue !== "" && (
                <span>
                  <Select
                    value={orderDayfilter}
                    className={classes.dayAutocomplete}
                    onChange={handleSelectOrderDay}
                    sx={{
                      height: 40,
                    }}
                    MenuProps={{
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                      },
                      transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                      },
                      getContentAnchorEl: null,
                    }}
                  >
                    {orderDayMenuItems.map((name) => (
                      <MenuItem
                        key={name.index}
                        value={name.lable}
                        onClick={() => {
                          setOrderDayValue(name.value);
                          if (showDataBasedOnRole === "user") {
                            getList({
                              after_order_date_hour: name.value,
                            });
                          }
                        }}
                      >
                        {name.lable}
                      </MenuItem>
                    ))}
                  </Select>
                </span>
              )}
            {/* {width >= 1300 && ( */}
            <TextField
              withPadding={true}
              medium
              secondary
              className={classes.search}
              placeholder="Search..."
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e?.target?.value);
                handleSearch(e?.target?.value);
              }}
              InputProps={{
                endAdornment: (
                  <>
                    <InputAdornment position="end">
                      <PrimaryIcon width="20px" icon={SearchIcon} />
                    </InputAdornment>
                  </>
                ),
              }}
            />
            {/* )} */}

            {(width > 990 || (width <= 768 && width > 669)) && (
              <>
                <Box className={classes.rsiconBtnForFilter}>
                  <Box>
                    <Button onClick={handleClickFilter}>
                      <FilterListIcon />
                      <Box className={classes.filterCount}>
                        {filterCount > 0 && filterCount}
                      </Box>
                      Filter
                    </Button>
                    {filterCount > 0 && (
                      <IconButton onClick={handleClickFilterClear}>
                        <ModalCloseIcon />
                      </IconButton>
                    )}
                  </Box>
                  <Menu
                    id="long-menu"
                    MenuListProps={{
                      "aria-labelledby": "long-button",
                    }}
                    anchorEl={anchorEl}
                    open={openFilter}
                    onClose={handleCloseFilter}
                    PaperProps={{
                      style: {
                        padding: "10px",
                        // maxHeight: ITEM_HEIGHT * 4.5,
                        width: "32ch",
                      },
                    }}
                  >
                    <li className={classes.customMenuItem} disableRipple>
                      <Box
                        display={width > 600 ? "flex" : "block"}
                        alignItems={"center"}
                        justifyContent={"flex-start"}
                      >
                        <FormGroup className={classes.formAlignment}>
                          <FormControlLabel
                            className={
                              checkedCollection
                                ? classes.activecheck
                                : classes.rsSurgeryFormControl
                            }
                            control={
                              <Checkbox
                                checkedIcon={<CheckIcon />}
                                className={
                                  checkedCollection ? "uncollect_effect" : ""
                                }
                                color="secondary"
                                checked={checkedCollection}
                                onChange={handleSelectCollection}
                              />
                              // <Checkbox
                              //   color="secondary"
                              //   checked={checkedCollection}
                              //   onChange={handleSelectCollection}
                              // />
                            }
                            label="Waiting prescriptions only"
                          />
                        </FormGroup>
                      </Box>
                    </li>
                    <hr />
                    <li
                      className={classes.rsCursor}
                      onClick={() => handleDriverOpen()}
                    >
                      <Box className={classes.rsListAlignment}>
                        <Box>
                          Drivers
                          {/* {Object.keys(changeSurgeryDropDownValue).length !== 0 && (
                        <Box className={classes.rsActiveBtn}></Box>
                      )} */}
                        </Box>
                        <PrimaryIcon
                          width="20px"
                          height="20px"
                          icon={
                            driverOpen
                              ? KeyboardArrowUpOutlinedIcon
                              : KeyboardArrowDownOutlinedIcon
                          }
                        />
                      </Box>
                    </li>
                    <Collapse in={driverOpen}>
                      <ul className={classes.rsWaringFilterlistview}>
                        <li>
                          <DriverAutoComplete
                            fullWidth
                            multiple
                            className={clsx(
                              "autoCompleteBox",
                              classes.rsSurgeryAutoCompleteWebOther,
                            )}
                            value={changeDropDownValue}
                            maxValue={maxValue}
                            driverListFlag={driverListFlag}
                            handleChange={(value) => handleDriverChange(value)}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Driver List"
                              />
                            )}
                          />
                        </li>
                      </ul>
                    </Collapse>
                  </Menu>
                </Box>

                <HtmlTooltip title="Print">
                  <Button
                    className={classes.printButton}
                    variant="outlined"
                    disabled={printSurgeryList?.loading}
                    startIcon={
                      printSurgeryList?.isLoading && (
                        <CircularProgress
                          size="20px"
                          className="rsCircularIcon"
                        />
                      )
                    }
                    onClick={() => {
                      handelGetSurgeryPrintData();
                    }}
                  >
                    <PrimaryIcon
                      icon={PrintIcon}
                      color="primary"
                      width="26px"
                      height="26px"
                    />
                  </Button>
                </HtmlTooltip>
              </>
            )}

            <Box
              className="ColumnMain"
              onClick={(e) => {
                setColumnsPopperAnchorEl(e.currentTarget);
                if (
                  ["pharmacist_staff", "pharmacy"].indexOf(
                    showDataBasedOnRole,
                  ) !== -1
                ) {
                  setSurgeryRecordActionType("pharmacyDragDrop");
                } else {
                  setSurgeryRecordActionType("surgeryDragDrop");
                }
                setOpenTableColumn(true);
              }}
            >
              <HtmlTooltip title="Columns">
                <Box>
                  <Button
                    className="ColumnBtn"
                  // onClick={() => {
                  //   if (
                  //     ["pharmacist_staff", "pharmacy"].indexOf(
                  //       showDataBasedOnRole
                  //     ) !== -1
                  //   ) {
                  //     setSurgeryRecordActionType("pharmacyDragDrop");
                  //   } else {
                  //     setSurgeryRecordActionType("surgeryDragDrop");
                  //   }
                  //   setOpenTableColumn(true);
                  // }}
                  >
                    <PrimaryIcon
                      color="black"
                      width="20px"
                      icon={ViewWeekIcon}
                      cursor="pointer"
                    />
                    Columns
                    <PrimaryIcon
                      color="black"
                      width="30px"
                      icon={ArrowDropDownIcon}
                      cursor="pointer"
                    />
                  </Button>
                </Box>
              </HtmlTooltip>
            </Box>
          </Grid>
        </Box>

        {/* Table */}

        <Box className={classes.rsGrid}>
          <Grid
            className={clsx(
              "common-table",
              width < 1175
                ? // && showDataBasedOnRole === "user"
                classes.managePageHMob
                : classes.managePageH,
            )}
            sx={
              {
                // "& .MuiTableContainer-root": {
                //   maxHeight:
                //     showDataBasedOnRole === "user"
                //       ? "calc(97vh - 200px) !important"
                //       : "",
                // },
              }
            }
          >
            <SurgeryTable
              columnSortingOrder={columnSortingOrder}
              setColumnSortingOrder={setColumnSortingOrder}
              defaultColumnOrderBy={defaultColumnOrderBy}
              surgeryList={surgeryList}
              setSurgeryRecordActionType={setSurgeryRecordActionType}
              setIsOpenSurgeryModel={setIsOpenSurgeryModel}
              setEditSurgeryData={setEditSurgeryData}
              setDeleteSurgery={setDeleteSurgery}
              setSurgeryDeleteId={setSurgeryDeleteId}
              setPatientCount={setPatientCount}
              setShowNoteList={setShowNoteList}
              setOpenNoteList={setOpenNoteList}
              setTarget={setTarget}
              showDataBasedOnRole={showDataBasedOnRole}
              tableCells={tableColumns}
              setIsOpenEditDateModel={setIsOpenEditDateModel}
              setEditRepeatDate={setEditRepeatDate}
              setCol={setCol}
              checkedCollection={checkedCollection}
              changeDropDownValue={changeDropDownValue}
              searchValue={searchValue}
            />
          </Grid>
        </Box>
      </Grid>
      {/* {isOpenSurgeryModel && ( */}
      <CreateSurgeryDialog
        open={isOpenSurgeryModel}
        setOpen={setIsOpenSurgeryModel}
        editData={editSurgeryData}
        setEditData={setEditSurgeryData}
        surgeryRecordActionType={surgeryRecordActionType}
        surgeryListRecordLimit={surgeryListRecordLimit}
        driverList={driverList}
        resetPatientState={resetPatientState}
        setShowNoteList={setShowNoteList}
        setOpenNoteList={setOpenNoteList}
        setDeleteSurgery={setDeleteSurgery}
        setSurgeryDeleteId={setSurgeryDeleteId}
        setPatientCount={setPatientCount}
        setTarget={setTarget}
        getList={getList}
        col={col}
        setCol={setCol}
      />
      {/* )} */}
      <EditPhoneDialog
        open={isOpenEditDateModel}
        setOpen={setIsOpenEditDateModel}
        editData={editRepeatDate}
        setEditData={setEditRepeatDate}
        getList={getList}
        col={col}
        setCol={setCol}
      />
      <PrintSurgeryList
        surgeryList={printSurgeryList}
        showPatientData={showPatientData}
        tableColumns={tableColumns}
      />
      <NotesDialog
        open={openNoteList}
        setOpen={setOpenNoteList}
        title="Surgery Note"
        subTitle="NOTE DETAIL"
        body={showNoteList}
        actionBtnTitle="Ok"
        getSurgeryNoteListAction={getSurgeryNoteListAction}
        createSurgeryNoteListAction={createSurgeryNoteListAction}
        updateSurgeryNoteListAction={updateSurgeryNoteListAction}
        getSingletSurgeryNoteListAction={getSingletSurgeryNoteListAction}
        deleteSurgeryNoteListAction={deleteSurgeryNoteListAction}
        surgeryNoteList={surgeryNoteList}
        createSurgeryNoteData={createSurgeryNoteData}
        updateSurgeryNoteData={updateSurgeryNoteData}
        singleSurgeryNote={singleSurgeryNote}
        deleteSurgeryNoteData={deleteSurgeryNoteData}
        resetSurgeryState={resetSurgeryState}
      />
      <ConfirmationDialog
        open={deleteSurgery}
        setOpen={setDeleteSurgery}
        title="Are you sure?"
        body="You wan't be able to undo this surgery!"
        subTitle={`${patientCount > 0
            ? `This surgery cannot be deleted as it is already assigned to ${patientCount} ${patientCount > 1 ? "patients" : "patient"
            }.`
            : ""
          }`}
        handleSubmit={handleDeleteSurgery}
        actionBtnTitle="Yes Delete It!"
        loading={deleteSurgeryData?.loading}
      />
      <SearchAndFilterDialogSurgeryMobileView
        open={openFilterPopup}
        setOpen={setOpenFilterPopup}
        maxValue={maxValue}
        driverListFlag={driverListFlag}
        changeDropDownValue={changeDropDownValue}
        handleDriverChange={handleDriverChange}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        handleSearch={handleSearch}
        openFilterPopup={openFilterPopup}
        orderDayfilter={orderDayfilter}
        handleSelectOrderDay={handleSelectOrderDay}
        orderDayMenuItems={orderDayMenuItems}
        showDataBasedOnRole={showDataBasedOnRole}
        setOrderDayValue={setOrderDayValue}
        getList={getList}
      />
      <TableColumnShowMenu
        open={openTableColumn}
        setOpen={setOpenTableColumn}
        anchorEl={columnsPopperAnchorEl}
        tableColumns={tableColumns}
        setTableColumns={setTableColumns}
        onOrderChange={(newOrder) => setTableColumns(newOrder)}
        tableCells={tableCells}
        surgeryRecordActionType={surgeryRecordActionType}
        moduleName={"surgery"}
        showDataBasedOnRole={showDataBasedOnRole}
      />
      <SubscriptionWaringDailog
        open={subscriptionDialog}
        setOpen={setSubscritionDialog}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  globalSetting: state.order.globalSetting,
  surgeryList: state.surgery.surgeryList,
  deleteSurgeryData: state.surgery.deleteSurgeryData,
  driverList: state.surgery.driverList,
  surgeryNoteList: state.surgery.surgeryNoteList,
  createSurgeryNoteData: state.surgery.createSurgeryNoteData,
  updateSurgeryNoteData: state.surgery.updateSurgeryNoteData,
  singleSurgeryNote: state.surgery.singleSurgeryNote,
  deleteSurgeryNoteData: state.surgery.deleteSurgeryNoteData,
  printSurgeryList: state.surgery.printSurgeryList,
});
const mapDispatchToProps = (dispatch) => ({
  getStaffListAction: (payload) =>
    dispatch({ type: START_GET_STAFF_LIST, payload }),
  getSurgeryListAction: (payload) =>
    dispatch({ type: START_GET_SURGERY_LIST, payload }),
  deleteSurgeryAction: (id) => dispatch({ type: START_DELETE_SURGERY, id }),
  resetSurgeryState: (key, payload) =>
    dispatch({ type: RESET_SURGERY_STATE, key, payload }),
  getSurgeryNoteListAction: (payload) =>
    dispatch({ type: START_GET_SURGERY_NOTE_LIST, payload }),
  createSurgeryNoteListAction: (payload) =>
    dispatch({ type: START_CREATE_SURGERY_NOTE, payload }),
  updateSurgeryNoteListAction: (id, payload) =>
    dispatch({ type: START_UPDATE_SURGERY_NOTE, id, payload }),
  getSingletSurgeryNoteListAction: (id) =>
    dispatch({ type: START_GET_SINGLE_SURGERY_NOTE, id }),
  deleteSurgeryNoteListAction: (id) =>
    dispatch({ type: START_DELETE_SURGERY_NOTE, id }),
  resetPatientState: (key, payload) =>
    dispatch({ type: RESET_PATIENT_STATE, key, payload }),
  getPrintSurgeryListAction: (payload) =>
    dispatch({ type: START_GET_PRINT_SURGERY_LIST, payload }),
  getHomeListAction: (payload) =>
    dispatch({ type: START_GET_HOME_LIST, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(SurgeriesMain);
